import { ICustomFormElement } from "./Abstract";

import { InputText } from "./Input";

class Range extends InputText implements ICustomFormElement {
    protected rangeValueElement: HTMLSpanElement;
    protected minValueElement: HTMLSpanElement;
    protected maxValueElement: HTMLSpanElement;
    protected infinite: boolean = false;
    protected percentage: boolean = false;
    protected customSteps: any[] = [];

    /**
     * initialize elements
     */
    initElements() {
        super.initElements().initAttributes();
        this.rangeValueElement = this.querySelector<HTMLSpanElement>("span.range-value");

        if (this.dataset.infinite) {
            this.infinite = Boolean(JSON.parse(this.dataset.infinite));
        }

        if (this.dataset.percentage) {
            this.percentage = Boolean(JSON.parse(this.dataset.percentage));
        }

        this.value = this.getAttribute("value")
            ? this.getAttribute("value")
            : this.label.classList.contains("has-value")
            ? this.value
            : this.min;

        if (this.value) {
            this.rangeValueElement.innerText = this.value;
        }

        this.minValueElement = this.querySelector<HTMLSpanElement>("span.min-value");
        this.maxValueElement = this.querySelector<HTMLSpanElement>("span.max-value");

        if (this.min) {
            this.minValueElement.innerText = this.min;
        }
        if (this.max) {
            this.maxValueElement.innerText = this.max;
        }

        if (this.value && this.min && this.max) {
            this.setRangeElementValue(this.value, this.max);
            this.setProgressBackgroundSize(parseInt(this.value), parseInt(this.min), parseInt(this.max));
        }

        if (this.dataset.customSteps) {
            this.customSteps = this.dataset.customSteps.split(",");
            this.setCustomSteps();
        }

        return this;
    }

    attachEvents() {
        this.input.addEventListener("input", () => {
            this.setRangeElementValue(this.value, this.max);
            this.setProgressBackgroundSize(parseInt(this.value), parseInt(this.min), parseInt(this.max));

            if (this.customSteps.length > 0) {
                this.setCustomSteps();
            }
        });
        return super.attachEvents();
    }

    private setProgressBackgroundSize(value: number, min: number, max: number) {
        this.shadow
            .querySelector("input")
            .style.setProperty("--background-size-progress", ((value - min) * 100) / (max - min) + "% 100%");
    }

    private setRangeElementValue(value: string, max: string) {
        this.rangeValueElement.innerText = this.infinite && value === max ? value + "+" : value;
    }

    private setCustomSteps() {
        this.rangeValueElement.innerText = this.customSteps[parseInt(this.value)];
        this.minValueElement.innerText = this.customSteps[0].toString();
        this.maxValueElement.innerText = this.customSteps[this.customSteps.length - 1].toString();
    }

    get value() {
        return super.value;
    }

    set value(v: string) {
        super.value = v;
        this.input.dispatchEvent(new Event("input"));
    }
}

Range.prototype.template = document.createElement("template");
Range.prototype.shadowStyle = document.createElement("template");
Range.prototype.shadowStyle.innerHTML = `
<style>
input[type="range"] {
    width: 100%;
    background: var(--color-grey-med1);
    background-image: linear-gradient(var(--color-black), var(--color-black));
    background-repeat: no-repeat;
    background-size: var(--background-size-progress, 100% 100%);
    margin: 0;
    padding: 0;
    -webkit-appearance: none;
    outline: none;
    cursor: default;
    height: 2px;
}
input[type="range"]::-webkit-slider-runnable-track {
   background-color: transparent;
}

input[type="range"]::-moz-range-track {
   background-color: transparent;
}

input[type="range"]::-ms-track {
   background-color: transparent;
}

input[type="range"]::-moz-range-progress {
   background-color: transparent;
}

input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: var(--color-primary);
    width: 1.125rem;
    height: 1.125rem;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 3px solid var(--color-white);
    box-sizing: content-box;
    box-shadow: var(--box-shadow-50);
}
input[type="range"]::-moz-range-thumb {
    -webkit-appearance: none;
    background: var(--color-primary);
    width: 1.125rem;
    height: 1.125rem;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 3px solid var(--color-white);
    box-sizing: content-box;
    box-shadow: var(--box-shadow-50);
}
</style>
`;

Range.prototype.template.innerHTML = /*html*/ `
<label class="std-fe">
    <span class="label"><slot></slot></span>
    <span class="range-value"></span>
    <span class="input"></span>
</label>
<span class="min-max-values">
    <span class="min-value"></span>
    <span class="max-value"></span>
</span>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-range", Range);
